'use strict';

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

function _StateController() {
  this.id = null;
  this.node = null;
  this.declaredClass = null;
  this.extends = [_LayoutReducers, _AccountReducers, _CryptoReducers];

  this.init = function () {};

  this.initAllReady = function () {};

  this.createStore = function () {
    if (!window.mogo.registry.mogoUI.appState) {
      var rootReducer = Redux.combineReducers({
        layout: this.layoutReducer,
        account: this.accountReducer,
        loan: this.loanReducer,
        crypto: this.cryptoReducer
      }).bind(this);

      window.mogo.registry.mogoUI.appState = Redux.createStore(rootReducer);
      this.render();
      window.mogo.registry.mogoUI.appState.subscribe(this.render.bind(this));
    }
  };

  this.render = function () {
    if (this.presenter.models.appState == null || !this.presenter.models.appState._initialized) {
      this.presenter.createModel('appState', {
        data: window.mogo.registry.mogoUI.appState.getState()
      });
    } else {
      this.presenter.updateModel('appState', window.mogo.registry.mogoUI.appState.getState());
    }
  };
}

// Reducer Utils:

function updateObject(oldObject, newValues) {
  // Encapsulate the idea of passing a new object as the first parameter
  // to Object.assign to ensure we correctly copy data instead of mutating
  return _extends({}, oldObject, newValues);
}

function updateItemInArray(array, itemId, updateItemCallback) {
  var updatedItems = array.map(function (item) {
    if (item.id !== itemId) {
      // Since we only want to update one item, preserve all others as they are now
      return item;
    }

    // Use the provided callback to create an updated item
    var updatedItem = updateItemCallback(item);
    return updatedItem;
  });

  return updatedItems;
}

function createReducer(initialState, handlers) {
  return function reducer() {
    var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : initialState;
    var action = arguments[1];

    if (handlers.hasOwnProperty(action.type)) {
      return handlers[action.type](state, action);
    }
    return state;
  };
}